export default {
  SET_CARDS (state, payload) {
    state.cards = payload
  },

  SET_CARD (state, card) {
    state.card = card
    // Apenas atualizar tabs se vier com tabs na resposta
    // Se não vier, mantém as tabs existentes (não zera)
    if (card && card.tabs && Array.isArray(card.tabs)) {
      state.tabs = card.tabs
    } else if (!state.tabs) {
      // Apenas inicializa como array vazio se ainda não existe
      state.tabs = []
    }
    // Caso contrário, mantém as tabs existentes
  },

  SET_TABS (state, tabs) {
    state.tabs = tabs
  },

  ADD_TAB (state, tab) {
    state.tabs.push(tab)
  },

  UPDATE_TAB (state, { tabId, data }) {
    var index = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (index !== -1) {
      state.tabs[index] = Object.assign({}, state.tabs[index], data)
    }
  },

  REMOVE_TAB (state, tabId) {
    state.tabs = state.tabs.filter(function (t) { return t.id !== tabId })
  },

  REORDER_TABS (state, tabs) {
    // Criar novo array para forçar reatividade
    state.tabs = [...tabs]
  },

  SET_FIELDS (state, { tabId, fields }) {
    var tabIndex = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (tabIndex !== -1) {
      var tab = state.tabs[tabIndex]
      // Force reactivity by creating new tab with new fields array
      state.tabs[tabIndex] = Object.assign({}, tab, { fields: [...fields] })
      // Force the tabs array to update
      state.tabs = [...state.tabs]
    }
  },

  ADD_FIELD (state, { tabId, field }) {
    var tabIndex = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (tabIndex !== -1) {
      var tab = state.tabs[tabIndex]
      if (!tab.fields) {
        // Force reactivity by creating a new array
        state.tabs[tabIndex] = Object.assign({}, tab, { fields: [field] })
      } else {
        // Force reactivity by creating a new array with the new field
        state.tabs[tabIndex] = Object.assign({}, tab, {
          fields: [...tab.fields, field]
        })
      }
      // Force the tabs array to update
      state.tabs = [...state.tabs]
    }
  },

  UPDATE_FIELD (state, { tabId, fieldId, data }) {
    var tabIndex = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (tabIndex !== -1) {
      var tab = state.tabs[tabIndex]
      if (tab && tab.fields) {
        var fieldIndex = tab.fields.findIndex(function (f) { return f.id === fieldId })
        if (fieldIndex !== -1) {
          // Create new fields array with updated field
          var newFields = [...tab.fields]
          newFields[fieldIndex] = Object.assign({}, tab.fields[fieldIndex], data)
          state.tabs[tabIndex] = Object.assign({}, tab, { fields: newFields })
          // Force the tabs array to update
          state.tabs = [...state.tabs]
        }
      }
    }
  },

  REMOVE_FIELD (state, { tabId, fieldId }) {
    var tabIndex = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (tabIndex !== -1) {
      var tab = state.tabs[tabIndex]
      if (tab && tab.fields) {
        // Force reactivity by creating a new array without the removed field
        var newFields = tab.fields.filter(function (f) { return f.id !== fieldId })
        state.tabs[tabIndex] = Object.assign({}, tab, { fields: newFields })
        // Force the tabs array to update
        state.tabs = [...state.tabs]
      }
    }
  },

  REORDER_FIELDS (state, { tabId, fields }) {
    var tabIndex = state.tabs.findIndex(function (t) { return t.id === tabId })
    if (tabIndex !== -1) {
      var tab = state.tabs[tabIndex]
      // Force reactivity by creating new tab with new fields array
      state.tabs[tabIndex] = Object.assign({}, tab, { fields: [...fields] })
      // Force the tabs array to update
      state.tabs = [...state.tabs]
    }
  },

  SET_AVAILABLE_FIELDS (state, availableFields) {
    state.availableFields = availableFields
  },

  SET_SELECTED_TAB (state, tab) {
    state.selectedTab = tab
  },

  SET_SELECTED_FIELD (state, field) {
    state.selectedField = field
  },

  SET_PREVIEW_GROUP_ID (state, groupId) {
    state.previewGroupId = groupId
  },

  SET_DIRTY (state, isDirty) {
    state.isDirty = isDirty
  },

  SET_LOADING (state, isLoading) {
    state.isLoading = isLoading
  },

  RESET_BUILDER (state) {
    state.card = null
    state.tabs = []
    state.fields = []
    state.selectedTab = null
    state.selectedField = null
    state.isDirty = false
  }
}
